import { CALL_ACCOUNT_SYSTEM_API } from '../../middleware/authHeaders'
import { ACCOUNT_SYSTEM_API_ROOT } from '../../config/api'

export const ACCOUNTS_GET_AUTH_ORG_REQUEST = 'ACCOUNTS_GET_AUTH_ORG_REQUEST'
export const ACCOUNTS_GET_AUTH_ORG_SUCCESS = 'ACCOUNTS_GET_AUTH_ORG_SUCCESS'
export const ACCOUNTS_GET_AUTH_ORG_FAILURE = 'ACCOUNTS_GET_AUTH_ORG_FAILURE'

export const getAccountsAuthOrg = orgId => dispatch => {
  return dispatch({
    [CALL_ACCOUNT_SYSTEM_API]: {
      method: 'GET',
      endpoint: `${ACCOUNT_SYSTEM_API_ROOT}/v2/organizations/${orgId}`,
      types: [
        ACCOUNTS_GET_AUTH_ORG_REQUEST,
        ACCOUNTS_GET_AUTH_ORG_SUCCESS,
        ACCOUNTS_GET_AUTH_ORG_FAILURE,
      ],
    },
  })
}

export const ACCOUNTS_EDIT_AUTH_ORG_REQUEST = 'ACCOUNTS_EDIT_AUTH_ORG_REQUEST'
export const ACCOUNTS_EDIT_AUTH_ORG_SUCCESS = 'ACCOUNTS_EDIT_AUTH_ORG_SUCCESS'
export const ACCOUNTS_EDIT_AUTH_ORG_FAILURE = 'ACCOUNTS_EDIT_AUTH_ORG_FAILURE'

export const editAccountsAuthOrg = (orgId, payload) => dispatch => {
  return dispatch({
    [CALL_ACCOUNT_SYSTEM_API]: {
      method: 'PATCH',
      endpoint: `${ACCOUNT_SYSTEM_API_ROOT}/v2/organizations/${orgId}`,
      body: JSON.stringify(payload),
      types: [
        ACCOUNTS_EDIT_AUTH_ORG_REQUEST,
        ACCOUNTS_EDIT_AUTH_ORG_SUCCESS,
        ACCOUNTS_EDIT_AUTH_ORG_FAILURE,
      ],
    },
  })
}

export const ACCOUNTS_CREATE_AUTH_ORG_REQUEST = 'ACCOUNTS_CREATE_AUTH_ORG_REQUEST'
export const ACCOUNTS_CREATE_AUTH_ORG_SUCCESS = 'ACCOUNTS_CREATE_AUTH_ORG_SUCCESS'
export const ACCOUNTS_CREATE_AUTH_ORG_FAILURE = 'ACCOUNTS_CREATE_AUTH_ORG_FAILURE'

export const createAccountsAuthOrg = payload => dispatch => {
  return dispatch({
    [CALL_ACCOUNT_SYSTEM_API]: {
      method: 'POST',
      endpoint: `${ACCOUNT_SYSTEM_API_ROOT}/v2/organizations`,
      body: JSON.stringify(payload),
      types: [
        ACCOUNTS_CREATE_AUTH_ORG_REQUEST,
        ACCOUNTS_CREATE_AUTH_ORG_SUCCESS,
        ACCOUNTS_CREATE_AUTH_ORG_FAILURE,
      ],
    },
  })
}

export const ACCOUNTS_GET_AUTH_ORG_CONNECTIONS_REQUEST = 'ACCOUNTS_GET_AUTH_ORG_CONNECTIONS_REQUEST'
export const ACCOUNTS_GET_AUTH_ORG_CONNECTIONS_SUCCESS = 'ACCOUNTS_GET_AUTH_ORG_CONNECTIONS_SUCCESS'
export const ACCOUNTS_GET_AUTH_ORG_CONNECTIONS_FAILURE = 'ACCOUNTS_GET_AUTH_ORG_CONNECTIONS_FAILURE'

export const getAccountsAuthOrgConnections = orgId => dispatch => {
  return dispatch({
    [CALL_ACCOUNT_SYSTEM_API]: {
      method: 'GET',
      endpoint: `${ACCOUNT_SYSTEM_API_ROOT}/v2/organizations/${orgId}/connections`,
      types: [
        ACCOUNTS_GET_AUTH_ORG_CONNECTIONS_REQUEST,
        ACCOUNTS_GET_AUTH_ORG_CONNECTIONS_SUCCESS,
        ACCOUNTS_GET_AUTH_ORG_CONNECTIONS_FAILURE,
      ],
    },
  })
}

export const ACCOUNTS_DELETE_AUTH_ORG_CONNECTION_REQUEST =
  'ACCOUNTS_DELETE_AUTH_ORG_CONNECTION_REQUEST'
export const ACCOUNTS_DELETE_AUTH_ORG_CONNECTION_SUCCESS =
  'ACCOUNTS_DELETE_AUTH_ORG_CONNECTION_SUCCESS'
export const ACCOUNTS_DELETE_AUTH_ORG_CONNECTION_FAILURE =
  'ACCOUNTS_DELETE_AUTH_ORG_CONNECTION_FAILURE'

export const deleteAccountsAuthOrgConnection = (orgId, connectionId) => dispatch => {
  return dispatch({
    [CALL_ACCOUNT_SYSTEM_API]: {
      method: 'DELETE',
      endpoint: `${ACCOUNT_SYSTEM_API_ROOT}/v2/organizations/${orgId}/connections/${connectionId}`,
      types: [
        ACCOUNTS_DELETE_AUTH_ORG_CONNECTION_REQUEST,
        ACCOUNTS_DELETE_AUTH_ORG_CONNECTION_SUCCESS,
        ACCOUNTS_DELETE_AUTH_ORG_CONNECTION_FAILURE,
      ],
    },
  })
}

export const ACCOUNTS_ENABLE_AUTH_ORG_CONNECTION_REQUEST =
  'ACCOUNTS_ENABLE_AUTH_ORG_CONNECTION_REQUEST'
export const ACCOUNTS_ENABLE_AUTH_ORG_CONNECTION_SUCCESS =
  'ACCOUNTS_ENABLE_AUTH_ORG_CONNECTION_SUCCESS'
export const ACCOUNTS_ENABLE_AUTH_ORG_CONNECTION_FAILURE =
  'ACCOUNTS_ENABLE_AUTH_ORG_CONNECTION_FAILURE'

export const enableAccountsAuthOrgConnection = (orgId, connectionId) => dispatch => {
  const payload = {
    connectionId,
    assignMembershipOnLogin: true,
  }
  return dispatch({
    [CALL_ACCOUNT_SYSTEM_API]: {
      method: 'POST',
      endpoint: `${ACCOUNT_SYSTEM_API_ROOT}/v2/organizations/${orgId}/connections/`,
      body: JSON.stringify(payload),
      types: [
        ACCOUNTS_ENABLE_AUTH_ORG_CONNECTION_REQUEST,
        ACCOUNTS_ENABLE_AUTH_ORG_CONNECTION_SUCCESS,
        ACCOUNTS_ENABLE_AUTH_ORG_CONNECTION_FAILURE,
      ],
    },
  })
}

export const ACCOUNTS_GET_AUTH_CONNECTIONS_REQUEST = 'ACCOUNTS_GET_AUTH_CONNECTIONS_REQUEST'
export const ACCOUNTS_GET_AUTH_CONNECTIONS_SUCCESS = 'ACCOUNTS_GET_AUTH_CONNECTIONS_SUCCESS'
export const ACCOUNTS_GET_AUTH_CONNECTIONS_FAILURE = 'ACCOUNTS_GET_AUTH_CONNECTIONS_FAILURE'

export const getAccountsAuthConnections =
  (page = 0, pageSize = 10) =>
  dispatch => {
    return dispatch({
      [CALL_ACCOUNT_SYSTEM_API]: {
        method: 'GET',
        endpoint: `${ACCOUNT_SYSTEM_API_ROOT}/v2/connections/?page=${page}&pageSize=${pageSize}`,
        types: [
          ACCOUNTS_GET_AUTH_CONNECTIONS_REQUEST,
          ACCOUNTS_GET_AUTH_CONNECTIONS_SUCCESS,
          ACCOUNTS_GET_AUTH_CONNECTIONS_FAILURE,
        ],
      },
    })
  }

export const ACCOUNTS_CLEAR_ORG_CONNECTION = 'ACCOUNTS_CLEAR_ORG_CONNECTION'
export const clearAccountsAuthOrgConnection = connectionId => ({
  type: ACCOUNTS_CLEAR_ORG_CONNECTION,
  payload: connectionId,
})

export const ACCOUNTS_CLEAR_SELECTED_AUTH_ORG = 'ACCOUNTS_CLEAR_SELECTED_AUTH_ORG'
export const clearAccountsSelectedAuthOrg = () => ({
  type: ACCOUNTS_CLEAR_SELECTED_AUTH_ORG,
})

// SELECTORS
export const selectAccountsAuthOrgsSlice = state => state.accounts.accountsAuthOrgs
export const selectSelectedAuthOrg = state => selectAccountsAuthOrgsSlice(state).selectedAuthOrg
export const selectedAvailableConnections = state =>
  selectAccountsAuthOrgsSlice(state).availableConnectionsResponse

// STATE
const initialState = {
  selectedAuthOrg: null,
  availableConnectionsResponse: null,
}

// REDUCERS
const accountsAuthOrgs = (state = initialState, { type, payload } = {}) =>
  ({
    [ACCOUNTS_GET_AUTH_ORG_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      selectedAuthOrg: newPayload,
    }),
    [ACCOUNTS_GET_AUTH_ORG_FAILURE]: currentState => ({
      ...currentState,
      selectedAuthOrg: null,
    }),
    [ACCOUNTS_GET_AUTH_ORG_CONNECTIONS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      selectedAuthOrg: {
        ...currentState.selectedAuthOrg,
        orgEnabledConnections: newPayload,
      },
    }),
    [ACCOUNTS_CLEAR_SELECTED_AUTH_ORG]: currentState => ({
      ...currentState,
      selectedAuthOrg: null,
    }),
    [ACCOUNTS_ENABLE_AUTH_ORG_CONNECTION_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      selectedAuthOrg: {
        ...currentState.selectedAuthOrg,
        orgEnabledConnections: [...currentState.selectedAuthOrg.orgEnabledConnections, newPayload],
      },
    }),
    [ACCOUNTS_EDIT_AUTH_ORG_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      selectedAuthOrg: newPayload,
    }),
    [ACCOUNTS_CREATE_AUTH_ORG_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      selectedAuthOrg: newPayload,
    }),
    [ACCOUNTS_CLEAR_ORG_CONNECTION]: currentState => ({
      ...currentState,
      selectedAuthOrg: {
        ...currentState.selectedAuthOrg,
        orgEnabledConnections: currentState.selectedAuthOrg.orgEnabledConnections.filter(
          x => x.connectionId !== payload
        ),
      },
    }),
    [ACCOUNTS_GET_AUTH_CONNECTIONS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      availableConnectionsResponse: newPayload,
    }),
  }[type]?.(state, payload) || state)

export default accountsAuthOrgs
